/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { TaskStatusEnumType } from './TaskStatusEnum'
import { RootStoreType } from './index'

/**
 * DailyTaskBase
 * auto generated base class for the model DailyTaskModel.
 */
export const DailyTaskModelBase = ModelBase.named('DailyTask')
  .props({
    __typename: types.optional(types.literal('DailyTask'), 'DailyTask'),
    _id: types.identifier,
    createdAt: types.union(types.undefined, types.frozen()),
    date: types.union(types.undefined, types.string),
    id: types.union(types.undefined, types.number),
    status: types.union(types.undefined, TaskStatusEnumType),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DailyTaskModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get date() {
    return this.__attr('date')
  }
  get id() {
    return this.__attr('id')
  }
  get status() {
    return this.__attr('status')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromDailyTask() {
  return new DailyTaskModelSelector()
}

export const dailyTaskModelPrimitives = selectFromDailyTask()._id.createdAt.date.status.updatedAt.userId
